import _classCallCheck from "/workspace/src/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/workspace/src/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
var colors = ['#16AFF0', '#23C1E3', '#AB7BD0'];

var CalendarColorCycler = /*#__PURE__*/function () {
  function CalendarColorCycler() {
    _classCallCheck(this, CalendarColorCycler);

    this.position = 0;
  }

  _createClass(CalendarColorCycler, [{
    key: "next",
    value: function next() {
      var color = colors[this.position];
      this.position = (this.position + 1) % colors.length;
      return color;
    }
  }, {
    key: "getColorAtPosition",
    value: function getColorAtPosition(position) {
      return colors[position % colors.length];
    }
  }]);

  return CalendarColorCycler;
}();

export { CalendarColorCycler as default };